var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99121 7.15009L1.64313 4.80201C1.48082 4.6397 1.21781 4.63924 1.05492 4.80097L0.462926 5.3888C0.299633 5.55094 0.298701 5.81476 0.460843 5.97805L0.461883 5.9791L3.69658 9.2138C3.8593 9.37652 4.12312 9.37652 4.28584 9.2138L12.0299 1.46972C12.1926 1.307 12.1926 1.04318 12.0299 0.880463L11.4442 0.294719L11.444 0.29489C11.2814 0.132239 11.0177 0.132162 10.8549 0.294719L3.99121 7.15009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/checkMark.5ab2635e.svg";
export { ForwardRef as ReactComponent };